// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1157":"0957ed87","3834":"0957ed87","4337":"0957ed87","5116":"0957ed87","5527":"0957ed87","6546":"72891663","8619":"511349ce"}[chunkId] + ".chunk.css";
};